import type {PluginBaseInfo} from '@packages/systems/ix3/core';

export const CORE_PLUGIN_INFO: PluginBaseInfo = {
  namespace: 'wf',
  pluginId: 'core',
  version: '1.0.0',
};

export * from './types';
export * from './mouseFollowRelationships';
export * from './transientElements';
